import { getFilterDisplayName } from "../../utils/getFilterDisplayName";
import { XClose } from "untitledui-js-base";
import { FC } from "react";

interface Props {
  filter: string;
  onRemove: () => void;
}

export const FilterBadge: FC<Props> = ({ filter, onRemove }) => {
  return (
    <div className="py-2 px-4 items-center border border-alpha-40 bg-primary-20 text-primary-600 text-xs font-medium rounded-lg flex gap-1.5 justify-between">
      <p className="max-w-[100px] truncate">{getFilterDisplayName(filter)}</p>
      <button onClick={onRemove}>
        <XClose size="18" className="stroke-primary-600" />
      </button>
    </div>
  );
};
